export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'zh-CN',
  missingWarn: false,
  fallbackWarn: false,
}))
